import { render } from "./UnixDateRange.vue?vue&type=template&id=0130f3c4"
import script from "./UnixDateRange.vue?vue&type=script&lang=js"
export * from "./UnixDateRange.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__